module.exports = __webpack_public_path__ + "static/media/c088677c-ef3e-4a6e-ac49-3a0bdd785689-3.2293c4fd.woff";